<template>
  <div>
    <div
      class="btn-group-toggle d-flex agent-property-details-tab border-t"
      data-toggle="buttons"
    >
      <div class="uni-max-sm">
        <label class="btn btn-secondary col agent-prop-tab active">
          <input type="radio" checked @click="listingType('SALE')" />
          <span>Sale</span>
        </label>
        <label class="btn btn-secondary col agent-prop-tab">
          <input type="radio" @click="listingType('RENT')" />
          <span>Rent</span>
        </label>
        <label class="btn btn-secondary col agent-prop-tab">
          <input type="radio" @click="listingType('AUCTION')" />
          <span>Auction</span>
        </label>
      </div>
    </div>

    <div class="d-flex flex-wrap uni-max-sm my-3" v-if="isloaded && !iserror">
      <div v-for="(row, index) in rows" :key="index" class="p4-propcard">
        <a :href="'/' + ltype.toLowerCase() + '/' + row.slug">
          <div class="p4-propimg">
            <img v-lazy="row.featured_photo.medium.url" :alt="row.id" />
          </div>
        </a>
        <div class="p4-propbody">
          <a
            :href="'/' + ltype.toLowerCase() + '/' + row.slug"
            class="p4-proptitle mb-2"
          >
            <span class="text-capitalize">{{
              row.property_type_name.toLowerCase()
            }}</span>
            <span v-if="row.property_type_name && row.project"> at </span>
            <span class="text-capitalize">
              {{ row.project.toLowerCase() }}</span
            >
            <span v-if="row.area && row.project">, </span>
            <span class="text-capitalize"> {{ row.area.toLowerCase() }}</span>
          </a>
          <div class="p4-proploc py-2 text-capitalize">
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.4106 7.56055C11.4106 7.16456 11.331 6.77246 11.1763 6.40661C11.0217 6.04077 10.7951 5.70836 10.5093 5.42835C10.2236 5.14835 9.88443 4.92624 9.51112 4.7747C9.13781 4.62316 8.7377 4.54517 8.33364 4.54517C7.92957 4.54517 7.52946 4.62316 7.15615 4.7747C6.78284 4.92624 6.44364 5.14835 6.15792 5.42835C5.8722 5.70836 5.64556 6.04077 5.49093 6.40661C5.3363 6.77246 5.25671 7.16456 5.25671 7.56055C5.25671 8.15803 5.43693 8.71372 5.74243 9.1824H5.73891C6.77627 10.7741 8.33364 13.1606 8.33364 13.1606L10.9284 9.1824H10.9253C11.2419 8.69837 11.4104 8.13552 11.4106 7.56055ZM8.33364 8.85286C7.9839 8.85286 7.64849 8.7167 7.40119 8.47435C7.15389 8.232 7.01496 7.90329 7.01496 7.56055C7.01496 7.21781 7.15389 6.88911 7.40119 6.64675C7.64849 6.4044 7.9839 6.26824 8.33364 6.26824C8.68337 6.26824 9.01878 6.4044 9.26609 6.64675C9.51339 6.88911 9.65232 7.21781 9.65232 7.56055C9.65232 7.90329 9.51339 8.232 9.26609 8.47435C9.01878 8.7167 8.68337 8.85286 8.33364 8.85286Z"
                fill="#AFAFAF"
              />
            </svg>
            <div style="max-width: calc(100% - 27px)">
              {{ row.area.toLowerCase() }}, {{ row.state.toLowerCase() }}
            </div>
          </div>
          <div class="d-flex flex-nowrap w-100 align-items-center">
            <div class="d-flex flex-nowrap p4-pricepad align-items-center">
              <div v-if="row.rent_view_to_offer || row.sale_view_to_offer" class="p4-propprice text-nowrap">
                  Open to offer price
              </div>
              <div
                v-else-if="row.for_sale && ltype == 'SALE'"
                class="p4-propprice text-nowrap"
              >
                RM {{ addComma(row.sale_selling_price) }}
              </div>
              <div
                v-else-if="row.for_rent && ltype == 'RENT'"
                class="p4-propprice text-nowrap"
              >
                RM {{ addComma(row.monthly_rental_price) }}
              </div>
              <div
                v-else-if="row.for_auction && ltype == 'AUCTION'"
                class="p4-propprice text-nowrap"
              >
                RM {{ addComma(row.auction_reserve_price) }}
              </div>
            </div>
            <div
              class="ml-auto p4-pricepad align-items-center"
            >
              <div class="dropdown">
                <a
                  class="btn btn-sm btn-icon-only text-light dropdown-toggle-btn"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9282 1.34483C11.9282 1.01631 11.6619 0.75 11.3334 0.75C11.0049 0.75 10.7385 1.01631 10.7385 1.34483V10.4052H1.6782C1.34969 10.4052 1.08337 10.6715 1.08337 11C1.08337 11.3285 1.34969 11.5948 1.6782 11.5948H10.7385V20.6552C10.7385 20.9837 11.0049 21.25 11.3334 21.25C11.6619 21.25 11.9282 20.9837 11.9282 20.6552V11.5948H20.9885C21.3171 11.5948 21.5834 11.3285 21.5834 11C21.5834 10.6715 21.3171 10.4052 20.9885 10.4052H11.9282V1.34483Z"
                      fill="#D80000"
                      stroke="#D80000"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right dropdown-menu-arrow"
                >
                  <label>Actions</label>
                  <ul>
                    <li>
                      <a
                        href="#"
                        @click="updateWatchList($event, index)"
                        ><span class="icon"
                          ><svg
                            width="16"
                            height="10"
                            viewBox="0 0 16 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M13.7594 0.433126C13.6012 0.0705315 13.1737 -0.097454 12.8045 0.0579203C12.4353 0.213295 12.2642 0.633192 12.4224 0.995787L13.2851 2.97292C12.9908 2.89745 12.682 2.85727 12.3636 2.85727C10.7044 2.85727 9.30478 3.94864 8.8683 5.44031C8.58509 5.37191 8.29358 5.337 7.99998 5.337C7.70638 5.337 7.41488 5.37191 7.13169 5.4403C6.69521 3.94863 5.29555 2.85727 3.63636 2.85727C1.62805 2.85727 0 4.45622 0 6.42863C0 8.40104 1.62805 10 3.63636 10C5.48222 10 7.00686 8.64925 7.24143 6.89928C7.48362 6.81112 7.7406 6.76554 7.99998 6.76554C8.25936 6.76554 8.51636 6.81113 8.75856 6.8993C8.99314 8.64926 10.5178 10 12.3636 10C14.3719 10 16 8.40104 16 6.42863L16 6.00775C15.9999 5.71758 15.9397 5.43016 15.8233 5.16348L13.7594 0.433126ZM10.1818 6.44117C10.1887 7.61885 11.1629 8.57145 12.3636 8.57145C13.5686 8.57145 14.5454 7.61208 14.5454 6.42863C14.5454 5.24519 13.5686 4.28581 12.3636 4.28581C11.1626 4.28581 10.1882 5.2389 10.1818 6.41699C10.182 6.42504 10.182 6.4331 10.1818 6.44117ZM3.63636 4.28581C2.43138 4.28581 1.45454 5.24519 1.45454 6.42863C1.45454 7.61208 2.43138 8.57145 3.63636 8.57145C4.83655 8.57145 5.8104 7.61971 5.81813 6.44276C5.81796 6.43363 5.81796 6.4245 5.81814 6.4154C5.81089 5.23804 4.83685 4.28581 3.63636 4.28581Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M3.19554 0.0579203C3.56473 0.213295 3.73578 0.633192 3.57757 0.995787L1.51357 5.72642C1.47481 5.81516 1.45465 5.91097 1.45454 6.00753V6.42863C1.45454 6.82312 1.12893 7.14292 0.727272 7.14292C0.325611 7.14292 0 6.82312 0 6.42863V6.00722C0.000223723 5.71741 0.0603044 5.43011 0.176606 5.16376L2.2406 0.433126C2.39881 0.0705314 2.82635 -0.097454 3.19554 0.0579203Z"
                              fill="white"
                            />
                          </svg> </span
                        >{{
                          watch_lists.filter(
                            (watch_list) =>
                              watch_list.property_id == row.id
                          ).length > 0
                            ? "Remove from"
                            : "Save to"
                        }}
                        watchlist</a
                      >
                    </li>
                    <li>
                      <a href="#" @click="toggleShare(row.id, $event)">
                        <span class="icon"
                          ><svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.8742 1.56248C6.87416 1.19592 7.003 0.841026 7.23819 0.559875C7.47339 0.278724 7.79995 0.0892234 8.16075 0.0245285C8.52155 -0.0401664 8.89361 0.0240638 9.21183 0.205981C9.53006 0.387899 9.77418 0.67592 9.9015 1.01965C10.0288 1.36338 10.0312 1.74094 9.90827 2.08626C9.78533 2.43158 9.54489 2.72268 9.229 2.90863C8.91311 3.09457 8.5419 3.16352 8.1803 3.10342C7.81871 3.04331 7.48977 2.85798 7.25102 2.57983L3.05286 4.52956C3.14937 4.83542 3.14937 5.16357 3.05286 5.46943L7.25102 7.41916C7.50339 7.12565 7.85573 6.93629 8.23976 6.88776C8.62378 6.83924 9.01215 6.935 9.3296 7.1565C9.64704 7.378 9.87095 7.70946 9.95794 8.08664C10.0449 8.46382 9.98879 8.85987 9.80041 9.19802C9.61203 9.53617 9.30483 9.79235 8.93834 9.9169C8.57184 10.0415 8.17216 10.0255 7.81674 9.87219C7.46133 9.71886 7.17549 9.43904 7.01463 9.08697C6.85377 8.73489 6.82933 8.33564 6.94607 7.96658L2.74791 6.01685C2.54008 6.25905 2.26307 6.43179 1.95413 6.51184C1.64519 6.59188 1.31915 6.57539 1.01986 6.46459C0.720572 6.35378 0.462398 6.15398 0.280069 5.89205C0.0977389 5.63012 0 5.31864 0 4.9995C0 4.68035 0.0977389 4.36887 0.280069 4.10694C0.462398 3.84501 0.720572 3.64521 1.01986 3.5344C1.31915 3.4236 1.64519 3.40711 1.95413 3.48715C2.26307 3.5672 2.54008 3.73994 2.74791 3.98214L6.94607 2.03241C6.89828 1.88035 6.87404 1.72187 6.8742 1.56248Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                        Share
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <share-btn
                :index="row.id"
                @remove="hideShare"
                :manualToggle="share_target"
                :title="
                  row.property_type_name +
                  ' at ' +
                  row.project +
                  ' ' +
                  row.area +
                  ' for ' +
                  ltype +
                  ' | Shijie Property 世界地產'
                "
                :text="
                  'Check out this ' +
                  row.property_type_name +
                  ' for ' +
                  ltype +
                  ' at ' +
                  row.project +
                  '!'
                "
                :label="row.project"
                :url="
                  '/' +
                  ltype.toLowerCase() +
                  '/' +
                  row.slug +
                  webid
                "
              ></share-btn>
            </div>
          </div>
        </div>
      </div>

      <!-- table pagination -->
      <div
        v-if="rows.length != 0 && isloaded"
        class="df-mn flex-row flex-wrap my-5 px-3 w-100"
        style="font-size: 14px"
      >
        <nav
          v-if="rows.length != 0"
          aria-label="pager"
          role="navigation"
          class="pagy-bootstrap-nav align-self-center"
        >
          <ul class="pagination d-flex flex-wrap justify-content-center">
            <li class="page-item prev" v-show="pagy.prev">
              <a
                @click="changePage(pagy.prev)"
                aria-label="previous"
                class="page-link"
              >
                <i class="fas fa-arrow-left"></i>
              </a>
            </li>
            <li
              v-for="index in pagy.series"
              :key="index"
              v-show="pagy.series"
              :class="{ active: index == pagy.page }"
              class="page-item"
            >
              <a
                v-if="index != 'gap'"
                @click="changePage(index)"
                class="page-link"
                >{{ index }}</a
              >
              <div v-else class="page-link">...</div>
            </li>
            <li class="page-item next" v-show="pagy.next">
              <a
                @click="changePage(pagy.next)"
                rel="next"
                aria-label="next"
                class="page-link"
              >
                <i class="fas fa-arrow-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div
      class="d-flex justify-content-center py-4 uni-max"
      v-else-if="!isloaded && !iserror"
    >
      <div class="text-center my-3 t-text" style="padding-bottom: 300px">
        <div class="spinner-border text-danger" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>

    <div
      class="d-flex justify-content-center py-4 uni-max"
      v-else-if="isloaded && iserror"
    >
      <div class="text-center my-3 t-text" style="padding-bottom: 300px">
        No result found.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "example-component",
  props: ["slug", "current_staff", "current_user"],
  data() {
    var wid = "";
    if (this.current_staff) {
      wid = "?marketer=" + this.current_staff.web_id;
    }

    return {
      webid: wid,
      path: "/agents/" + this.slug + "/listings",
      params: "?listing_type=SALE",
      ltype: "SALE",
      isloaded: true,
      iserror: false,
      curpage: 1,
      rows: [],
      pagy: [],
      watch_lists: [],
      share_target: "",
    };
  },
  watch: {
    params(val) {
      this.propertyList();
    },
  },
  beforeMount() {
    if (this.current_user) {
      this.getWatchList();
    }
  },
  mounted() {
    this.propertyList();
  },
  methods: {
    getWatchList: function (refetch = false) {
      if ($cookies.get("my_watch_lists") && !refetch) {
        this.watch_lists = $cookies.get("my_watch_lists");
      } else {
        let vm = this;
        this.$http
          .get(`/api/v1/user/watch_lists?scope=all`)
          .then((res) => {
            vm.watch_lists = res.data.watch_lists;
            $cookies.set("my_watch_lists", res.data.watch_lists);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    updateWatchList: function (e, index) {
      e.preventDefault();
      if (this.current_user) {
        let vm = this;
        const watch_list = this.watch_lists.filter(
          (watch_list) => watch_list.property_id == this.rows[index].id
        )?.[0];
        if (watch_list) {
          this.$http
            .delete(`/api/v1/user/watch_lists/${watch_list.id}`)
            .then((res) => {
              vm.$toast.success("Property removed from watchlist successful", {
                position: "top-right",
              });
              vm.getWatchList('refetch');
            })
            .catch((error) => {
              vm.$toast.warning(
                "Property failed remove from watchlist.. Please try again",
                {
                  position: "top-right",
                }
              );
            });
        } else {
          this.$http
            .post("/api/v1/user/watch_lists", {
              watch_list: {
                property_id: this.rows[index].id,
                listing_type: this.ltype,
              },
            })
            .then((res) => {
              vm.$toast.success("Property saved to watchlist successful", {
                position: "top-right",
              });
              vm.getWatchList('refetch');
            })
            .catch((error) => {
              vm.$toast.warning(
                "Property failed save to watchlist.. Please try again",
                {
                  position: "top-right",
                }
              );
            });
        }
      }
      else {
        this.$modal.show("login-modal");
      }
    },
    toggleShare: function (id, e) {
      if (e) {
        e.preventDefault();
      }
      this.share_target = id;
    },
    hideShare: function () {
        this.share_target = "";
    },
    changePage(newPage) {
      if (newPage != this.pagy.page) {
        this.curpage = newPage;
        this.propertyList();
      }
    },
    propertyList: function () {
      let vm = this;
      vm.isloaded = false;
      vm.iserror = false;
      this.$http
        .get(vm.path + vm.params + `&page=${vm.curpage}`)
        .then((response) => {
          vm.rows = response.data.data;
          vm.pagy = response.data.pagy;
          vm.isloaded = true;
        })
        .catch((error) => {
          vm.rows = [];
          vm.pagy = [];
          vm.iserror = true;
          vm.isloaded = true;
          console.log(error);
          console.log("change page");
        });
    },
    addComma: function (num) {
      var num_parts = num.toString().split(".");
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return num_parts.join(".");
    },
    listingType: function (type) {
      let vm = this;
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      vm.ltype = type;
      vm.params = "?listing_type=" + type;
      return vm.params && vm.ltype;
    },
  },
};
</script>